import React from 'react';
import PropTypes from 'prop-types';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import HardSkillProp from '../challenges/propTypes/hardSkillProp';
import TrophyProp from '../journey/propTypes/trophyProp';
import PerformanceProp from './propTypes/performanceProp';
import ChartsProp from './propTypes/chartsProp';
import CertificateProp from '../academy/propTypes/certificateProp';
import AppProductProp from './propTypes/appProductProp';
import StripeCardProp from './propTypes/StripeCardProp';
import { PROFILE_TABS } from '../../services/utilityFunctions';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import translate from '../../commonComponents/translate';
import Profile from './Profile';
import CurrencyProp from './propTypes/currencyProp';
import VatTypesProp from '../../commonComponents/forms/Address/VatTypesProp';

function ProfileWrapper(props) {
  const {
    t,
    activeTab,
    cards,
    countries,
    vatTypes,
    languages,
    allLanguages,
    currencies,
    experienceDomainSkills,
    hardSkills,
    stats,
    customTrophies,
    certificates,
    appProducts,
    userLanguage,
    directSellingActive,
  } = props;

  return (
    <Title title={t('profile_head_title')}>
      <ContentContainer>
        <div className="m-content">
          <div className="row full-page-container">
            <Profile
              cards={cards}
              countries={countries}
              vatTypes={vatTypes}
              activeTab={activeTab}
              languages={languages}
              allLanguages={allLanguages}
              currencies={currencies}
              experienceDomainSkills={experienceDomainSkills}
              hardSkills={hardSkills}
              customTrophies={customTrophies}
              stats={stats}
              certificates={certificates}
              appProducts={appProducts}
              userLanguage={userLanguage}
              directSellingActive={directSellingActive}
              {...props}
            />
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

ProfileWrapper.propTypes = {
  t: PropTypes.func.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
  userLanguage: PropTypes.string.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  vatTypes: PropTypes.arrayOf(PropTypes.shape(VatTypesProp.propType))
    .isRequired,
  activeTab: PropTypes.oneOf(PROFILE_TABS).isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  allLanguages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  experienceDomainSkills: PropTypes.arrayOf(PropTypes.string).isRequired,
  hardSkills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType))
    .isRequired,
  customTrophies: PropTypes.arrayOf(PropTypes.shape(TrophyProp.propType))
    .isRequired,
  stats: PropTypes.shape({
    performance: PropTypes.shape(PerformanceProp.propType),
    charts: PropTypes.shape(ChartsProp.propType),
  }).isRequired,
  certificates: PropTypes.arrayOf(PropTypes.shape(CertificateProp.propType))
    .isRequired,
  appProducts: PropTypes.arrayOf(PropTypes.shape(AppProductProp.propType))
    .isRequired,
  directSellingActive: PropTypes.bool.isRequired,
};

export default translate(ProfileWrapper);
